import React from 'react';
import './Header.css'

export default function Header() {
	return(
		<header>
			<h1 className='hero'>Hello! My name is Zacharia Lutz.</h1>
			<h2 className='hero'>I'm a web developer with a background in fine art and anthropology.</h2>
		</header>
	)
}